// extracted by mini-css-extract-plugin
export default {"page":"page-layout_page__Udmkh","blockScroll":"page-layout_blockScroll__QGom+","allowScroll":"page-layout_allowScroll__jhp05"};